import { BuilderConfig } from '../../types/Builder';
import { COLORS } from '../business-button/business-button.constants';
import BusinessHubHeroPlatFormIntegrations, { HeroPlatFormIntegrationsProps } from './business-hub-platform-integrations';

export const BusinessHubHeroPlatFormIntegrationsBuilderConfig = {
    name: 'Hero Platform Integrations',
    inputs: [
        {
            name: 'background',
            type: 'object',
            subFields: [
                {
                    name: 'backgroundImage',
                    type: 'file',
                    defaultValue: '',
                },
                {
                    name: 'backgroundColor',
                    type: 'color',
                    defaultValue: '',
                },
            ],
        },

        {
            name: 'content',
            type: 'object',
            subFields: [
                {
                    name: 'title',
                    type: 'html',
                    defaultValue: '',
                },
                {
                    name: 'description',
                    type: 'html',
                    defaultValue: '',
                },
                {
                    name: 'ctaText',
                    type: 'text',
                    defaultValue: '',
                },
                {
                    name: 'ctaLink',
                    type: 'text',
                    defaultValue: '',
                },
                {
                    name: 'image',
                    type: 'file',
                    defaultValue: '',
                },
                {
                    name: 'imageMobile',
                    type: 'file',
                    defaultValue: '',
                },
                {
                    name: 'backgroundButton',
                    type: 'string',
                    enum: Object.values(COLORS),
                    defaultValue: COLORS.BLACK,
                },
            ],
        },
    ],
};

const builderConfig: BuilderConfig<HeroPlatFormIntegrationsProps> = {
    component: BusinessHubHeroPlatFormIntegrations,
    config: BusinessHubHeroPlatFormIntegrationsBuilderConfig,
};

export default builderConfig;
